export default __webpack_public_path__ + "static/media/wild-animals.4a18be5c.png";